export default "__VITE_ASSET__DQcPJ8ID__"